import { VersionedAgentSchema } from "@redotech/redo-model/agents/versioned-agent";
import * as z from "zod/v4";

export const listAgentsByName = {
  name: "listAgentsByName" as const,
  input: VersionedAgentSchema.pick({ name: true }),
  output: z.array(VersionedAgentSchema),
};
